<template>
  <div class="row">
    <div class="col-md-4 col-lg-4 col-xl-3">
      <label class="h6 text-md-right">
        {{label}}<br>
        <small class="text-black-50">{{labelSecondary}}</small>
      </label>
    </div>
    <div class="col-md-8 col-lg-8 col-xl-9">
      <div class="input-group">
        <input type="text" class="form-control" :placeholder="placeholder" v-model="fieldInput" v-on:keyup.enter="actionTagUpload()">
        <div class="input-group-append">
          <button class="btn btn-primary" type="button" v-on:click="actionTagUpload()">Add</button>
        </div>
      </div>
      <div v-if="addedTags.length > 0" class="addedTags my-2">
        <div v-for="tag in addedTags" v-bind:key="tag.id">
          <button type="button" class="btn btn-link p-0" v-on:click="removeTag(tag.id)"><i class="fa fa-window-close" aria-hidden="true"></i></button>
          {{tag.value}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'label',
    'labelSecondary',
    'isRequired',
    'placeholder'
  ],
  data () {
    return {
      addedTags: [],
      fieldInput: ''
    }
  },
  methods: {
    removeTag: function (id) {
      this.addedTags = this.addedTags.filter(x => x.id !== id)
      this.emitChange()
    },
    actionTagUpload: function () {
      this.addedTags.push({value: this.fieldInput, id: new Date().getTime()})
      this.fieldInput = ''
      this.emitChange()
    },
    emitChange: function () {
      console.log(this.addedTags.map(x => x.value).join())
      this.$emit('addedFieldTagContent', {label: this.label, content: this.addedTags, validated: true})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FieldTagAdd.vue